export const reportHistoryHeaders = {
  ticketNo: {
    name: "Ticket No",
    width: 0.25,
  },
  orderNo: {
    name: "Order No",
    width: 0.3,
  },
  issueType: {
    name: "Issue",
    width: 0.35,
  },
  createdAt: {
    name: "Date Created",
    width: 0.4,
  },
  createdByEmail: {
    name: "Created By",
    width: 0.4,
  },
  status: {
    name: "Status",
    width: 0.25,
    textAlign: "center",
    justifyContent: "center",
  },
};

export const mdReportHistoryHeaders = {
  ticketNo: {
    name: "Ticket No",
    width: 0.25,
  },
  orderNo: {
    name: "Order No",
    width: 0.3,
  },
  issueType: {
    name: "Issue",
    width: 0.35,
  },
};

export const smReportHistoryHeaders = {
  ticketNo: {
    name: "Ticket No",
    width: 0.25,
  },
  orderNo: {
    name: "Order No",
    width: 0.3,
  },
  issueType: {
    name: "Issue",
    textAlign: "center",
    width: 0.35,
  },
};
